import React, { Suspense } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import "./styles/index.scss";
import Footer from "./components/global/footer";
import AuthorizedRoute from "./utils/authorizedRoute";
import ClinicNearMe from "./components/clinicNearMe";
import Navbar from "./components/global/navbar";
import MobileModal from "./components/global/mobileModal";
import Main from "./components/global/main";
import Home from "./pages/home";
import Login from "./pages/login";
import PrivateLogin from "./components/privateLogin";
import PrivateRoute from "./utils/privateRoute";
import ContextProvider from "./utils/globalContext";
import PasswordReset from "./pages/passwordReset";
import PasswordChange from "./pages/passwordChange";
import ProductPortal from "./pages/productPortal";
import Page from "./pages/page";
import useAnalytics from "./hooks/useAnalytics";
import TagManager from "react-gtm-module";
import NormalizedRoute from "./utils/normalizedRoute";
import StoreManager from "./utils/storeManager";
import WaWidget from "./components/global/waWidget";
import Geolocation from "./components/geolocation";
import Form from "./pages/form";
import TopBanner from "./components/global/topBanner";

if (
  !/prerender/i.test(navigator.userAgent) &&
  process.env.REACT_APP_BUILD_ENV === "production" &&
  process.env.REACT_APP_GTM_ID
)
  TagManager.initialize({ gtmId: process.env.REACT_APP_GTM_ID });

const Analytics = () => {
  useAnalytics();
  return null;
};

function App() {
  return (
    <div id="app">
      <Suspense>
        <Router>
          <PrivateLogin>
            <Main>
              <Geolocation />
              <StoreManager />
              <ContextProvider>
                <Analytics />
                <WaWidget />
                <TopBanner />
                <Navbar />
                <Switch>
                  <PrivateRoute exact path="/product-portal" component={ProductPortal} />
                  <Route exact path="/change-your-password" component={PasswordChange} />
                  <Route exact path="/password/reset" component={PasswordReset} />
                  <Route exact path="/login" component={Login} />
                  <AuthorizedRoute exact path={"/:country"} component={Home} />
                  <AuthorizedRoute exact path="/sg/clinic-near-me" component={ClinicNearMe} />
                  <AuthorizedRoute exact path="/:country/:subdomain/:slug" component={Form} />
                  <AuthorizedRoute exact path="/:country/:slug" component={Page} />
                  <AuthorizedRoute exact path="*" component={NormalizedRoute} />
                </Switch>
                <Footer />
                <MobileModal />
              </ContextProvider>
            </Main>
          </PrivateLogin>
        </Router>
      </Suspense>
    </div>
  );
}

export default App;
